import { escapeHtml, escapeHtmlBr, extractionrAreaCodeData } from '../utilities/index'

export default class lineup {

  constructor() {
    this.el = document.querySelector('.js-lineup')

    if (!this.el) {
      return
    }

    this.createLineup()
    this.attachEventTrack()
  }

  createLineup() {
    const lineupTitleData = extractionrAreaCodeData(
      '05',
      window.LIVESTATION.MAINCONTENT
    )[0].remarks
    const lineupItemData = extractionrAreaCodeData(
      '06',
      window.LIVESTATION.MAINCONTENT
    )

    if (!lineupTitleData && !lineupItemData.length) {
      return
    }

    const lineupTitleHtml = `
      <h2 class="fr-heading -h2 u-align-center fr-sp-pt-xxl fr-pc-mt-xxxl">${escapeHtmlBr(
      lineupTitleData
    )}</h2>
    `

    let lineupItemHtml = ''
    let lineupItemLength = 0

    for (let i = 0; i < lineupItemData.length; i++) {
      const item = lineupItemData[i]

      if (item.show === '0') {
        continue
      }

      lineupItemHtml += `
        <li class="lineup_item">
          <a class="js-trackEvent" href="${escapeHtml(
        item.store_url.pc
      )}" data-category="live-commerce_Click" data-label="lineup_${escapeHtml(
        item.store_name
      )}" target="_blank">
            <div class="u-imgAdjustBox" data-aspect-ratio="1:1">
              <picture class="u-imgAdjustBox_inner">
                <source srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-srcset="${escapeHtml(
        item.store_url.sp
      )}" type="image/jpeg"/>
                <img class="fr-img lazyload" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="${escapeHtml(
        item.store_url.sp
      )}" alt="" data-expand="300">
              </picture>
            </div>
            <p class="lineup_title">${escapeHtmlBr(item.store_name)}</p>
            <p class="lineup_body">${escapeHtmlBr(item.remarks)}</p>
          </a>
        </li>
      `

      lineupItemLength++
    }

    this.el.innerHTML = `
      <section class="ls-section">
        ${lineupTitleHtml}
        <ul class="lineup ${lineupItemLength < 4 ? '-center' : ''
      }">${lineupItemHtml}</ul>
      </section>
    `
  }

  async attachEventTrack() {
    try {
      const items = this.el.querySelectorAll(
        '.js-trackEvent'
      )

      if (!items.length) {
        return
      }

      const { attachEventTrack } = await import(
        /* webpackChunkName: "track" */
        './trackEvent/track'
      )

      attachEventTrack(items)
    } catch (error) {
      console.log(error)
    }
  }
}
